import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';
import CardHeader from '@/components/Card/CardHeader';
import Button from '@/components/CustomButtons/Button';
import CustomInput from '@/components/CustomInput/CustomInput';
import GridContainer from '@/components/Grid/GridContainer';
// core components
import GridItem from '@/components/Grid/GridItem';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import loader from '../../assets/img/loader.svg';
import { API_BASE_URL, bankNames } from '../../config';
import { getOrganizations } from '@/views/Organizations/Organizations.api';
import CountryDropdown from '@/components/CountryDropdown';

const fileToDataUri = (file) =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      resolve(event.target.result);
    };
    reader.readAsDataURL(file);
  });

const CreateFacility = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get('organizationId');
  const [name, setName] = useState('');
  const [message, setMessage] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [file, setFile] = useState(null);
  const [signatureImg, setSignatureImg] = useState('');
  const [signature, setSignature] = useState(null);
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [country, setCountry] = useState('');
  const [fileimg, setFileimg] = useState('');
  const [loaded, setLoaded] = useState(false);
  const [aptno, setAptno] = useState('');
  const [bankAcc, setBankAcc] = useState('');
  const [bankName, setBankName] = useState('');
  const [allowAddressUpdate, setAllowAddressUpdate] = useState(false);
  const [achMethod, setAchMethod] = useState('moov');
  const [tangoGroups, setTangoGroups] = useState([]);
  const [tangoAccounts, setTangoAccounts] = useState([]);
  const [tango_group_id, setTangoGroupId] = useState('');
  const [tango_account_id, setTangoAccountId] = useState('');
  const [moovAccounts, setMoovAccounts] = useState([]);
  const [moovPaymentMethods, setMoovPaymentMethods] = useState([]);
  const [moov_account_id, setMoovAccountId] = useState('');
  const [moov_payment_method_id, setMoovPaymentMethodId] = useState('');
  const [smartPayablesAccounts, setSmartPayablesAccounts] = useState([]);
  const [smartpayablesId, setSmartPayablesId] = useState('');
  const [routingNo, setRoutingNo] = useState('');
  const [bankAccAlias, setBankAccAlias] = useState('');
  const [achId, setAchId] = useState('');
  const [achCompanyName, setAchCompanyName] = useState('');
  const [organizations, setOrganizations] = useState([]);
  const [allowedRefundAttachments, setAllowedRefundAttachments] = useState([]);
  const [allowed_refund_types, setAllowedRefundTypes] = useState([]);
  const [outbound_pgp_public_key, setOutboundPgpPublicKey] = useState('');
  const [client_facility_id, setClientFacilityId] = useState('');

  const autocompleteRef = useRef(null);

  // Create refs for form fields that need focus
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const zipcodeRef = useRef(null);
  const addressRef = useRef(null);

  const handlePlaceSelect = () => {
    let addressObject = autocompleteRef.current.getPlace();
    let address = addressObject.address_components;
    let zip_code;
    let city_data;
    let state_data;
    let streetNo;
    let route;
    setCity('');
    setState('');
    setZipcode('');

    for (let i = 0; i < address.length; i++) {
      if (address[i] && address[i].types[0] == 'postal_code') {
        zip_code = address[i].long_name;
        setZipcode(zip_code);
      }
      if (address[i] && address[i].types[0] == 'street_number') {
        streetNo = address[i].long_name;
      }
      if (address[i] && address[i].types[0] == 'route') {
        route = address[i].long_name;
      }
      if (
        (address[i] && address[i].types[0] == 'locality') ||
        (address[i] && address[i].types[0] == 'sublocality_level_1')
      ) {
        city_data = address[i].long_name;
        setCity(city_data);
      }
      if (address[i] && address[i].types[0] == 'administrative_area_level_1') {
        state_data = address[i].long_name;
        setState(state_data);
      }
    }

    let requiredAddress;
    if (route && streetNo) {
      requiredAddress = streetNo + ' ' + route;
    } else if (route) {
      requiredAddress = route;
    } else if (streetNo) {
      requiredAddress = streetNo;
    }

    setAddress(requiredAddress);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    // Handle state mapping for different form fields
    switch (name) {
      case 'name':
        setName(value);
        break;
      case 'email':
        setEmail(value);
        break;
      case 'address':
        setAddress(value);
        break;
      case 'phone':
        setPhone(value);
        break;
      case 'city':
        setCity(value);
        break;
      case 'state':
        setState(value);
        break;
      case 'zipcode':
        setZipcode(value);
        break;
      case 'aptno':
        setAptno(value);
        break;
      case 'bankAcc':
        setBankAcc(value);
        break;
      case 'routingNo':
        setRoutingNo(value);
        break;
      case 'achId':
        setAchId(value);
        break;
      case 'achCompanyName':
        setAchCompanyName(value);
        break;
      case 'outbound_pgp_public_key':
        setOutboundPgpPublicKey(value);
        break;
      case 'client_facility_id':
        setClientFacilityId(value);
        break;
      default:
        break;
    }
  };

  const handleBankName = (event) => {
    setBankName(event.target.value);
  };

  const handleAchMethod = (event) => {
    setAchMethod(event.target.value);
  };

  const handleAddressUpdate = (event) => {
    setAllowAddressUpdate(event.target.value);
  };

  const handleAllowRefundAttachments = (event) => {
    const { checked, name } = event.target;
    setAllowedRefundAttachments((prevTypes) => {
      if (checked) {
        return [...prevTypes, name];
      } else {
        return prevTypes.filter((type) => type !== name);
      }
    });
  };

  const handleAllowedRefundTypesChange = (event) => {
    const { checked, name } = event.target;
    setAllowedRefundTypes((prev) => {
      if (checked) {
        return [...prev, name];
      } else {
        return prev.filter((type) => type !== name);
      }
    });
    if (!checked) {
      setAllowedRefundAttachments((prevTypes) =>
        prevTypes.filter((type) => type !== name),
      );
    }
  };

  const handleBankAccAlias = (event) => {
    const alphaNumericRegex = /^[a-zA-Z0-9]*$/;
    if (alphaNumericRegex.test(event.target.value))
      setBankAccAlias(event.target.value);
  };

  const handleUploadFile = (event) => {
    setFile(event.target.files[0]);
    setFileimg(URL.createObjectURL(event.target.files[0]));
  };

  const handleSignatureFile = (event) => {
    setSignature(event.target.files[0]);
    setSignatureImg(URL.createObjectURL(event.target.files[0]));
  };

  const remove = () => {
    setFileimg('');
    setFile(null);
  };

  const removeSignature = () => {
    setSignatureImg('');
    setSignature(null);
  };

  const cancelfrm = () => {
    setRedirect(true);
  };

  const onMoonAccountChange = (e) => {
    const accountId = e.target.value;
    setMoovAccountId(accountId);

    axios
      .get(API_BASE_URL + '/getMoovPaymentMethods/' + accountId)
      .then((res) => {
        setMoovPaymentMethods(res.data);
      });
  };

  const onMoovPaymentMethodChange = (e) => {
    setMoovPaymentMethodId(e.target.value);
  };

  const onSmartPayablesAccountChange = (e) => {
    setSmartPayablesId(e.target.value);
  };

  const onTangoGroupChange = (e) => {
    const groupId = e.target.value;
    setTangoGroupId(groupId);

    axios.get(API_BASE_URL + '/listTangoAccounts/' + groupId).then((res) => {
      setTangoAccounts(res.data.accounts);
    });
  };

  const onTangoAccountChange = (e) => {
    setTangoAccountId(e.target.value);
  };

  const createFacility = async (e) => {
    e.preventDefault();

    if (name === '') {
      alert('Please enter Facility name');
      nameRef.current?.focus();
      return false;
    } else if (email === '') {
      alert('Please enter Facility email');
      emailRef.current?.focus();
      return false;
    } else if (phone === '') {
      alert('Please enter Facility phone');
      phoneRef.current?.focus();
      return false;
    } else if (city === '') {
      alert('Please enter city');
      cityRef.current?.focus();
      return false;
    } else if (state === '') {
      alert('Please enter state');
      stateRef.current?.focus();
      return false;
    } else if (zipcode === '') {
      alert('Please enter zipcode');
      zipcodeRef.current?.focus();
      return false;
    } else if (address === '') {
      alert('Please enter Facility address');
      addressRef.current?.focus();
      return false;
    } else if (!Number(phone)) {
      alert('Phone should be in numbers only');
      phoneRef.current?.focus();
      return false;
    } else if (phone.length > 12) {
      alert('Phone number length should not be greater than 12');
      phoneRef.current?.focus();
      return false;
    } else if (!moov_account_id || !moov_payment_method_id) {
      alert('Please select moov account and payment method');
      return false;
    } else if (!allowed_refund_types.length) {
      alert(
        'You need to select at least on type of refund types (Consumer Payments/Insurance)',
      );
      return false;
    } else {
      setLoaded(true);

      const currentAddress = address;
      const requiredAddress = currentAddress + ', ' + aptno;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      formData.append('email', email);
      formData.append('address', requiredAddress);
      formData.append('phone', phone);
      formData.append('city', city);
      formData.append('state', state);
      formData.append('zipcode', zipcode);
      formData.append('country', country);
      formData.append('bankAcc', bankAcc);
      formData.append('routingNo', routingNo);
      formData.append('bankAccAlias', bankAccAlias);
      formData.append('achCompanyName', achCompanyName);
      formData.append('achId', achId);
      formData.append('tango_group_id', tango_group_id);
      formData.append('tango_account_id', tango_account_id);
      formData.append('moov_account_id', moov_account_id);
      formData.append('moov_payment_method_id', moov_payment_method_id);
      formData.append('smartpayables_id', smartpayablesId);
      formData.append('organization_id', organizationId);
      formData.append('bank_name', bankName);
      formData.append('allow_address_update', allowAddressUpdate);
      formData.append('ach_method', achMethod);
      formData.append(
        'allowed_refund_attachments',
        JSON.stringify(allowedRefundAttachments),
      );
      formData.append(
        'allowed_refund_types',
        JSON.stringify(allowed_refund_types),
      );
      formData.append('outbound_pgp_public_key', outbound_pgp_public_key);
      formData.append('client_facility_id', client_facility_id);

      if (signature) {
        const signatureDataUri = await fileToDataUri(signature);
        formData.append('signatureImg', signatureDataUri);
      }

      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      axios
        .post(API_BASE_URL + '/create_facility', formData, { headers: headers })
        .then((response) => {
          return response;
        })
        .then((res) => {
          console.log('sss', res, res && res.data);
          if (res && res.data && !res.data.err) {
            setRedirect(true);
            setLoaded(false);
          } else {
            console.log(res.data);
            alert(res && res.data && res.data.msg);
            setLoaded(false);
            setMessage(res.data.msg);
          }
        })
        .catch((err) => {
          setLoaded(false);
          setMessage(err.response?.data?.msg);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    axios.get(API_BASE_URL + '/listTangoGroups').then((res) => {
      setTangoGroups(res.data.groups);
    });

    axios.get(API_BASE_URL + '/getMoovAccounts').then((res) => {
      setMoovAccounts(res.data);
    });

    axios.get(API_BASE_URL + '/smartpayables').then((res) => {
      setSmartPayablesAccounts(
        res.data?.filter(
          (account) => account.organization_id === +organizationId,
        ) || [],
      );
    });

    getOrganizations().then((res) => {
      setOrganizations(res.data.organizations);
    });

    const google = window.google;
    if (google) {
      autocompleteRef.current = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete'),
        {},
      );

      autocompleteRef.current.addListener('place_changed', handlePlaceSelect);
    }

    return () => {
      if (autocompleteRef.current) {
        google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, []);

  if (redirect) {
    const url = organizationId
      ? `/admin/updateOrganization/${organizationId}#facilities`
      : '/admin/facilities';
    navigate(url);
  }

  return (
    <div>
      <form onSubmit={createFacility}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='primary'>
                <h4>{t('facilities.create.title')}</h4>
              </CardHeader>
              <CardBody>
                {loaded && (
                  <div className='loaders'>
                    <img src={loader} />
                  </div>
                )}

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('facilities.create.nameLabel')}
                      onChange={handleChange}
                      value={name}
                      id='name'
                      name='name'
                      inputRef={nameRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.emailLabel')}
                      id='email'
                      name='email'
                      onChange={handleChange}
                      value={email}
                      inputRef={emailRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.phoneLabel')}
                      id='phone'
                      name='phone'
                      onChange={handleChange}
                      value={phone}
                      type='text'
                      inputRef={phoneRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.addressLabel')}
                      id='autocomplete'
                      name='address'
                      onChange={handleChange}
                      value={address}
                      type='text'
                      inputRef={addressRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.aptLabel')}
                      id='aptno'
                      name='aptno'
                      onChange={handleChange}
                      value={aptno}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.cityLabel')}
                      id='city'
                      name='city'
                      onChange={handleChange}
                      value={city}
                      type='text'
                      inputRef={cityRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.stateLabel')}
                      id='state'
                      name='state'
                      onChange={handleChange}
                      value={state}
                      type='text'
                      inputRef={stateRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.zipcodeLabel')}
                      id='zipcode'
                      name='zipcode'
                      onChange={handleChange}
                      value={zipcode}
                      type='text'
                      inputRef={zipcodeRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CountryDropdown
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      name='country'
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.achCompanyLabel')}
                      id='achCompanyName'
                      name='achCompanyName'
                      onChange={handleChange}
                      value={achCompanyName}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.achIdLabel')}
                      id='achId'
                      name='achId'
                      onChange={handleChange}
                      value={achId}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          {t('facilities.create.tangoGroupLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          value={tango_group_id}
                          onChange={onTangoGroupChange}
                          name='group_id'
                          className='full-width-elem'>
                          {tangoGroups.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.group_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango-acc'>
                          {t('facilities.create.tangoAccountLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango-acc'
                          value={tango_account_id}
                          onChange={onTangoAccountChange}
                          name='group_id'
                          className='full-width-elem'>
                          {tangoAccounts.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.account_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='allow-address-update'>
                          {t('facilities.create.allowAddressUpdateLabel')}
                        </InputLabel>
                        <Select
                          labelId='allow-address-update'
                          value={allowAddressUpdate}
                          onChange={handleAddressUpdate}
                          name='allowAddressUpdate'
                          className='full-width-elem'>
                          <MenuItem value={'true'}>Yes</MenuItem>
                          <MenuItem value={'false'}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='ach-method'>
                          {t('facilities.create.achMethodLabel')}
                        </InputLabel>
                        <Select
                          labelId='ach-method'
                          value={achMethod}
                          onChange={handleAchMethod}
                          name='achMethod'
                          className='full-width-elem'>
                          <MenuItem value={'moov'}>Moov</MenuItem>
                          <MenuItem value={'default'}>Default</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-moov'>
                          {t('facilities.create.moovAccountLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-moov'
                          value={moov_account_id}
                          onChange={onMoonAccountChange}
                          name='group_id'
                          className='full-width-elem'>
                          {moovAccounts.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.account_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-moov-acc'>
                          {t('facilities.create.moovPaymentMethodsLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-moov-acc'
                          value={moov_payment_method_id}
                          onChange={onMoovPaymentMethodChange}
                          name='group_id'
                          className='full-width-elem'>
                          {moovPaymentMethods.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.holder_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-smartpayables'>
                          {t('facilities.create.smartPayablesAccountLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-smartpayables'
                          value={smartpayablesId}
                          onChange={onSmartPayablesAccountChange}
                          name='smartpayables_id'
                          className='full-width-elem'>
                          <MenuItem value=''>
                            <em>
                              {organizationId
                                ? smartPayablesAccounts.length === 0
                                  ? 'No SmartPayables accounts available for selected organization'
                                  : 'Select SmartPayables Account'
                                : 'Select organization first'}
                            </em>
                          </MenuItem>
                          {smartPayablesAccounts.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='bank-name'>
                          {t('facilities.create.bankNameLabel')}
                        </InputLabel>
                        <Select
                          labelId='bank-name'
                          value={bankName}
                          onChange={handleBankName}
                          name='bankName'
                          className='full-width-elem'>
                          {Object.values(bankNames).map((obj, index) => (
                            <MenuItem value={obj} key={index}>
                              {obj}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-org'>
                          {t('facilities.create.organizationsLabel')}
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-org'
                          value={organizationId}
                          name='organization_id'
                          className='full-width-elem'
                          disabled={organizationId}>
                          {organizations.map((obj, index) => (
                            <MenuItem value={obj && obj.id} key={index}>
                              {obj && obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText='Client Facility ID'
                      id='client_facility_id'
                      name='client_facility_id'
                      onChange={handleChange}
                      value={client_facility_id}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.bankAccountLabel')}
                      id='bankAcc'
                      name='bankAcc'
                      onChange={handleChange}
                      value={bankAcc}
                      type='number'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.routingNoLabel')}
                      id='routingNo'
                      name='routingNo'
                      onChange={handleChange}
                      value={routingNo}
                      type='number'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.bankAccAliasLabel')}
                      id='bankAccAlias'
                      name='bankAccAlias'
                      onChange={handleBankAccAlias}
                      value={bankAccAlias}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.create.pgpKeyLabel')}
                      id='outbound_pgp_public_key'
                      name='outbound_pgp_public_key'
                      onChange={handleChange}
                      value={outbound_pgp_public_key}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 4,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl component='fieldset'>
                      <FormLabel component='label'>
                        {t('facilities.create.allowedRefundTypesLabel')}
                      </FormLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes('regular')}
                              onChange={handleAllowedRefundTypesChange}
                              name='regular'
                            />
                          }
                          label='Consumer Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes(
                                'insurance',
                              )}
                              onChange={handleAllowedRefundTypesChange}
                              name='insurance'
                            />
                          }
                          label='Insurance Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes(
                                'business',
                              )}
                              onChange={handleAllowedRefundTypesChange}
                              name='business'
                            />
                          }
                          label='Business Payments'
                        />
                      </FormGroup>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl component='fieldset'>
                      <FormLabel component='label'>
                        {t('facilities.create.allowedRefundAttachmentsLabel')}
                      </FormLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('regular')
                              }
                              checked={allowedRefundAttachments.includes(
                                'regular',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='regular'
                            />
                          }
                          label='Consumer Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('insurance')
                              }
                              checked={allowedRefundAttachments.includes(
                                'insurance',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='insurance'
                            />
                          }
                          label='Insurance Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('business')
                              }
                              checked={allowedRefundAttachments.includes(
                                'business',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='business'
                            />
                          }
                          label='Business Payments'
                        />
                      </FormGroup>
                    </FormControl>
                  </GridItem>

                  <GridItem style={{ alignSelf: 'end' }}></GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-upload m-b-30 m-t-27'>
                      <label htmlFor='logo'>
                        {t('facilities.create.uploadLogoLabel')}
                      </label>
                      <br />
                      <label htmlFor='logo' className='custom-upload-btn'>
                        <span>Browse</span>
                        <input
                          id='logo'
                          name='logo'
                          type='file'
                          accept='.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp'
                          style={{ display: 'none' }}
                          onChange={handleUploadFile}
                        />
                      </label>
                    </div>
                    {fileimg ? (
                      <div className='preview-image' width='130'>
                        <img src={fileimg} width='130' />
                      </div>
                    ) : (
                      ''
                    )}

                    {fileimg ? (
                      <span
                        className='material-icons'
                        style={{ cursor: 'pointer' }}
                        onClick={remove}>
                        delete
                      </span>
                    ) : (
                      ''
                    )}
                  </GridItem>

                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-upload m-b-30 m-t-27'>
                      <label htmlFor='signature'>
                        {t('facilities.create.uploadSignatureLabel')}
                      </label>
                      <br />
                      <label htmlFor='signature' className='custom-upload-btn'>
                        <span>Browse</span>
                        <input
                          id='signature'
                          name='signature'
                          type='file'
                          accept='.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp'
                          style={{ display: 'none' }}
                          onChange={handleSignatureFile}
                        />
                      </label>
                    </div>
                    {signatureImg ? (
                      <div className='preview-image' width='130'>
                        <img src={signatureImg} width='130' />
                      </div>
                    ) : (
                      ''
                    )}

                    {signatureImg ? (
                      <span
                        className='material-icons'
                        style={{ cursor: 'pointer' }}
                        onClick={removeSignature}>
                        delete
                      </span>
                    ) : (
                      ''
                    )}
                  </GridItem>
                </GridContainer>
                {message && (
                  <GridContainer>
                    <GridItem xs={8} sm={8} md={6}>
                      <p style={{ color: 'red', padding: '10px 0' }}>
                        {message}
                      </p>
                    </GridItem>
                  </GridContainer>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color='primary' type='submit'>
                      {t('common.buttons.create')}
                    </Button>
                    <Button
                      color='primary'
                      onClick={cancelfrm}
                      className='btn-cancel'
                      style={{ marginLeft: '5px' }}>
                      {t('common.buttons.cancel')}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
};

export default CreateFacility;
